<template>
  <div >

    <div class="text-subtitle1 q-py-sm ">Loan</div>
    <template v-if="fieldValue !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
      <div class="full-width">
      <div class="row ">
        <div class="col-12 col-md-6 q-px-sm q-py-sm ">
          <FieldText
              v-model="fieldValue.creditor_name"
              :field="{layout_injected_label: 'Creditor Name', label: 'Creditor Name', required: true, requiredText: null, options: {}}"
              :hide_bottom_space="true"
          ></FieldText>
        </div>
        <div class="col-12 col-md-6 q-px-sm q-py-sm ">
          <FieldText
              v-model="fieldValue.account_number"
              :field="{layout_injected_label: 'Account Number', label: 'Account Number', required: false, requiredText: null, options: {}}"
              :hide_bottom_space="true"
          ></FieldText>
        </div>
      </div>
        <div class="row  ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.monthly_mortgage_payment"
                :field="{layout_injected_label: 'Monthly Mortgage Payment', label: 'Monthly Mortgage Payment', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.credit_limit"
                :field="{layout_injected_label: 'Credit Limit', label: 'Credit Limit', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
        </div>

        <div class="row  ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldMoney
                v-model="fieldValue.unpaid_balance"
                :field="{layout_injected_label: 'Unpaid Balance', label: 'Unpaid Balance', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <q-checkbox v-model="fieldValue.to_be_paid_off" label="To be paid off at or before closing" />
          </div>
        </div>

        <div class="row  ">
          <div class="col-12 col-md-6 q-px-sm q-py-sm ">
            <FieldSelect
                v-model="fieldValue.type"
                :field="{layout_injected_label: 'Type', label: 'Type', required: false, requiredText: null,
                options: {
                  'fha': 'FHA',
                  'va': 'VA',
                  'conventional': 'Conventional',
                  'usda_rd': 'USDA-RD',
                  'other': 'Other'
                }
                }"
                :hide_bottom_space="true"
            ></FieldSelect>
          </div>
        </div>
      </div>
      </q-form>

    </template>


  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import FieldText from "@/components/fields/FieldText";
import FieldSelect from "@/components/fields/FieldSelect";

import FieldMoney from "@/components/fields/FieldMoney";

import {mapActions} from "vuex";
export default {
  components: {

    FieldText,
    FieldSelect,
    FieldMoney,

  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
        real_estate_item: {
          address: "",
          unit: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          property_type: "",
          status: "",
          intended_occupancy: "",
          market_value: "",
          monthly_gross_rent_income: "",
          current_mortgage_balance: "",
          monthly_rent_net_income: "",
          monthly_mortgage_payment: "",
          monthly_insurance: "",
          loans: [],
        },
        loan: {
          creditor_name: "",
          account_number: "",
          monthly_mortgage_payment: "",
          credit_limit: "",
          unpaid_balance: "",
          to_be_paid_off: false,
          type: ""
        },
        loan_types: {}
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    AddItem() {

    },
    onSubmit() {

    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    onAddressSelected(real_estate_item) {
      this.fieldValue.city = real_estate_item.city;
      this.fieldValue.state = real_estate_item.state;
      this.fieldValue.zip = real_estate_item.zipcode;
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
.pac-container {
  z-index: 1000000;
}
</style>
